import React, { useState } from 'react';

import { modalMessages } from 'apps/web_forms/utils/constants';
import SaveDraftModal from 'apps/web_forms/components/SaveDraftModal';

export const DraftModal = ({ extraProps, description }) => {
  const [draftDescription, setDraftDescription] = useState(description);

  const {
    saveDraft = () => {},
    setDraftModalOpen = () => {}
  } = extraProps || {};

  return (
    <SaveDraftModal
      draftDescriptionInputValue={draftDescription}
      setDraftDescriptionInputValue={setDraftDescription}
      draftModalOpen={true}
      setDraftModalOpen={setDraftModalOpen}
      mainMessage={modalMessages.saveDraft.main}
      helpTip={modalMessages.saveDraft.tip}
      saveButtonText='Save'
      onSave={() => saveDraft(draftDescription)}
    />
  );
};